import { useParams } from "react-router-dom"

/** URL prefix for the current deck, e.g. "/play/2022-09-29". Empty string outside a deck route. */
export const useDeckBase = () => {
	const { deck } = useParams()
	return deck ? `/play/${deck}` : ""
}
